module.exports = __webpack_public_path__ + "static/media/grid-dark.535b7028.svg";